import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="7mm"
    height="7mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 26185 26185"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#000;stroke-width:748.144;stroke-linecap:round;stroke-linejoin:round}.fil0{fill:none;fill-rule:nonzero}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528324056800">
        <path
          id="path4665"
          d="M8563 21220c297 166 660 163 953-9 294-172 474-486 474-827v-53c0-1714 1389-3102 3103-3102 1713 0 3102 1388 3102 3102h0c0 353 187 679 492 856 304 177 680 178 986 5 2819-1602 4726-4632 4726-8099 0-2386-910-4556-2390-6204H6176c-1480 1648-2390 3818-2390 6204 0 3488 1930 6534 4777 8127z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 748.144,
          }}
        />
        <path
          id="path4629"
          d="M16195 11542c285 0 517 231 517 517 0 285-232 517-517 517-286 0-517-232-517-517 0-286 231-517 517-517z"
          className="fill-none stroke1"
          style={{
            // stroke: "#000",
            strokeWidth: 748.144,
          }}
        />
        <path
          id="path4633"
          d="M25811 13093c0 6853-5865 12718-12718 12718S374 19946 374 13093 6240 374 13093 374s12718 5866 12718 12719z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 748.144,
          }}
        />
        <path
          id="path4637"
          d="M17229 14126H8956c-571 0-1034-462-1034-1033v-2068c0-572 463-1035 1034-1035h8273c571 0 1034 463 1034 1035v2068c0 571-463 1033-1034 1033z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 748.144,
          }}
        />
        <path
          id="path4641"
          d="M8956 4820h1034"
          className="fill-none stroke1"
          style={{
            strokeWidth: 748.144,
          }}
        />
        <path
          id="path4645"
          d="M12059 4820h2067"
          className="fill-none stroke1"
          style={{
            strokeWidth: 748.144,
          }}
        />
        <path
          id="path4649"
          d="M9990 12059h4136"
          className="fill-none stroke1"
          style={{
            strokeWidth: 748.144,
          }}
        />
        <path
          id="path4653"
          d="M16195 4820h1034"
          className="fill-none stroke1"
          style={{
            strokeWidth: 748.144,
          }}
        />
        <path
          id="path4657"
          d="m5544 374-879 3257-3257 879"
          className="fill-none stroke1"
          style={{
            strokeWidth: 748.144,
          }}
        />
        <path
          id="path4661"
          d="m20641 374 879 3257 3257 879"
          className="fill-none stroke1"
          style={{
            strokeWidth: 748.144,
          }}
        />
        <path
          id="path4669"
          d="M14126 20331c0 571-462 1034-1033 1034-572 0-1034-463-1034-1034 0-572 462-1035 1034-1035 571 0 1033 463 1033 1035z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 748.144,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
